import React from "react";
import { motion } from "framer-motion";
import { Github, Linkedin, Mail, ArrowUp } from "lucide-react";
import portfolioData from "../../data/mock";
import Logo from "../ui/Logo";

const Footer = () => {
  const { personalInfo } = portfolioData;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative bg-ink-950 border-t border-ink-800/50">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollToTop();
              }}
              className="hover:opacity-80 transition-opacity duration-200 mb-3 inline-block"
            >
              <Logo />
            </a>
            <p className="text-slate-400 text-sm max-w-md">
              DevOps Engineer specializing in Azure infrastructure,
              Infrastructure as Code, CI/CD pipelines and Kubernetes.
            </p>
          </div>

          <div className="flex items-center gap-5">
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg border border-ink-800 flex items-center justify-center text-slate-300 hover:text-white hover:border-slate-600 transition-all duration-200"
              aria-label="GitHub"
            >
              <Github size={18} />
            </a>
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg border border-ink-800 flex items-center justify-center text-slate-300 hover:text-white hover:border-slate-600 transition-all duration-200"
              aria-label="LinkedIn"
            >
              <Linkedin size={18} />
            </a>
            <a
              href={`mailto:${personalInfo.email}`}
              className="w-10 h-10 rounded-lg border border-ink-800 flex items-center justify-center text-slate-300 hover:text-white hover:border-slate-600 transition-all duration-200"
              aria-label="Email"
            >
              <Mail size={18} />
            </a>
            <button
              onClick={scrollToTop}
              className="w-10 h-10 rounded-lg border border-ink-800 flex items-center justify-center text-slate-300 hover:text-brand-400 hover:border-brand-500/30 transition-all duration-200"
              aria-label="Back to top"
            >
              <ArrowUp size={18} />
            </button>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-ink-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-600 text-xs">
            &copy; {new Date().getFullYear()} Lucio Ortigosa. All rights reserved.
          </p>
          <p className="text-ink-700 text-xs">
            Built with React & Tailwind CSS
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
